import Card from "../card/card";
import Udokaportfolio from "../../image/udoka_portfolio.png";
import smarthotelimg from "../../image/portfolio/smartHotel.png";
import topestateimg from "../../image/portfolio/topEstate.png";
import moobooStore from "../../image/portfolio/mooboo store.jpg";
import buzzstone from "../../image/portfolio/buzzstone blog.jpg";
import phlox from "../../image/portfolio/phlox ecom.jpg";
import eduma from "../../image/portfolio/eduma school.jpg";

import turan from "../../image/portfolio/turan outfit store.jpg";
const Projects_Comp = () => {
    return (
        <div className="w-full flex flex-col items-center justify-center py-2 px-2 space-y-4">
            <div data-aos="fade-down" className="text-2xl font-mono font-bold  text-white"><span className="text-yellow-500">My</span> Recent Works</div>
        
        <div data-aos="fade-down" className="grid w-full grid-cols-1 md:grid-cols-3 place-items-center place-content-center gap-y-8">
        <Card image={moobooStore} builtWith="React/Axios, PHP/Laravel, MYSQL"
         clientName="Emeka Williams" projectName="Fashions e-store web app " 
          
          year="2023" description="Multi-pages, Beautiful Ui and Ux, user signup, user login, admin dashboard, user dashboard, payment gateway(paystack, fluterwave, stripe) etc"
           />   
        <Card image={buzzstone} builtWith="React/Axios, PHP/Laravel, MYSQL"
         clientName="Lynda Smith" projectName="Blog web app " 
          
          year="2023" description="Multi-pages, Beautiful Ui and Ux, authors & admin signup, authors & admin login, authors & admin dashboard etc"
           />   
        <Card image={eduma} builtWith="React/Axios, PHP/Laravel, MYSQL"
         clientName="Rakibian Aslam" projectName="School web app " 
          
          year="2023" description="Multi-pages, Beautiful Ui and Ux, signup, login, students dashboard, teachers dashboard, admin dashboard, payment gateway(stripe) etc"
           />   
        <Card image={phlox} builtWith="React/Axios, PHP/Laravel, MYSQL"
         clientName="Philomena Abdulahi" projectName="Electronics e-store web app " 
          
          year="2023" description="Multi-pages, Beautiful Ui and Ux, signup, login, admin dashboard, user dashboard, payment gateway(stripe) etc"
           />   
        <Card image={turan} builtWith="React/Axios, PHP/Laravel, MYSQL"
         clientName="Turan Fred" projectName="fashions e-store web app " 
          
          year="2023" description="Multi-pages, Beautiful Ui and Ux, signup, login, admin dashboard, user dashboard, payment gateway(stripe, flutterwave) etc"
           />  
           <Card image={smarthotelimg} builtWith="HTML, Tailwind CSS, Jquery/AJAX, PHP/Laravel, MYSQL"
         clientName="John Oluade" projectName="Hotel booking web app " 
          
          year="2022" description="Multi-pages, Beautiful Ui and Ux, user signup, user login, admin dashboard, user dashboard, payment gateway(paystack) etc" />   
        
        <Card image={topestateimg} builtWith="HTML, Tailwind CSS, Jquery/AJAX, PHP/Laravel, MYSQL"
         clientName="Thompson Mmadu" projectName="Real estate e-commerce web app " 
          
          year="2022" description="Multi-pages, Beautiful Ui and Ux, user signup, user login, admin dashboard, user dashboard, payment gateway(paystack, fluterwave, stripe) etc" /> 
        <Card image={Udokaportfolio} builtWith="React and Tailwind CSS"
         clientName="Otsu Udoka" projectName="Portfolio website"
      
          year="2021" description="Multi-pages, Beautiful Ui and Ux, Email messaging contact form" />   
           
        
        </div>
        
        </div>
    );
}

export default Projects_Comp;